export default "__VITE_ASSET__C2F8Ol3h__"